class ProductVariantAutoSelect extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.autoSelectVariantBasedOnCollection =
      this.autoSelectVariantBasedOnCollection.bind(this)
    this.trySelectVariant = this.trySelectVariant.bind(this)
    this.checkIfAlreadySelected = this.checkIfAlreadySelected.bind(this)
    this.determineTargetOption = this.determineTargetOption.bind(this)

    // Run auto-selection logic when component is connected
    this.autoSelectVariantBasedOnCollection()
  }

  checkIfAlreadySelected () {
    return this.els.optionButton.elements.some((button) => {
      const inputId = button.getAttribute('for')
      if (inputId) {
        const inputElement = document.getElementById(inputId)
        return (
          inputElement && inputElement.type === 'radio' && inputElement.checked
        )
      }
      return false
    })
  }

  determineTargetOption (collectionHandle, config) {
    if (!collectionHandle) return 'regular'

    const collections = config.collections
    if (!collections) return 'regular'

    // Check for petite collections
    if (
      collections.petite.some((keyword) =>
        collectionHandle.toLowerCase().includes(keyword.toLowerCase()),
      )
    ) {
      return 'petite'
    }

    // Check for tall collections
    if (
      collections.tall.some((keyword) =>
        collectionHandle.toLowerCase().includes(keyword.toLowerCase()),
      )
    ) {
      return 'tall'
    }

    return 'regular'
  }

  trySelectVariant (optionKey, config) {
    const optionNames = config.optionNames[optionKey]
    const namesArray = Array.isArray(optionNames) ? optionNames : [optionNames]

    for (const buttonDataName of namesArray) {
      const optionLabel = this.els.optionButton.elements.find(
        (button) => button.getAttribute('data-name') === buttonDataName,
      )

      if (optionLabel) {
        const inputId = optionLabel.getAttribute('for')
        const input = document.getElementById(inputId)

        if (input && !input.disabled) {
          input.checked = true
          input.dispatchEvent(new Event('change', { bubbles: true }))
          return true
        }
      }
    }
    return false
  }

  autoSelectVariantBasedOnCollection () {
    const config = window.theme?.strings?.variantAutoSelect
    if (!config) return

    if (this.checkIfAlreadySelected()) {
      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const collectionHandle = urlParams.get('collection')

    let targetOption = 'regular' // Default fallback
    if (collectionHandle) {
      targetOption = this.determineTargetOption(collectionHandle, config)
    }

    if (targetOption) {
      this.trySelectVariant(targetOption, config)
    }
  }
}

if (!customElements.get('product-variant-auto-select')) {
  customElements.define(
    'product-variant-auto-select',
    ProductVariantAutoSelect,
  )
}
